<script>
import ArrayList from '@shell/components/form/ArrayList';
import Row from './ProjectRow';
import { QUOTA_COMPUTED } from './shared';

export default {
  components: { ArrayList, Row },

  props: {
    mode: {
      type:     String,
      required: true,
    },
    value: {
      type:    Object,
      default: () => {
        return {};
      }
    },
    types: {
      type:    Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    this.$set(this.value, 'spec', this.value.spec || {});
    this.$set(this.value.spec, 'namespaceDefaultResourceQuota', this.value.spec.namespaceDefaultResourceQuota || { limit: {} });
    this.$set(this.value.spec, 'resourceQuota', this.value.spec.resourceQuota || { limit: {} });

    return { typeValues: Object.keys(this.value.spec.resourceQuota.limit) };
  },

  computed: { ...QUOTA_COMPUTED },

  methods: {
    updateType(i, type) {
      this.$set(this.typeValues, i, type);
    },
    remainingTypes(currentType) {
      return this.mappedTypes
        .filter(mappedType => !this.typeValues.includes(mappedType.value) || mappedType.value === currentType);
    },
    emitRemove(data) {
      this.$emit('remove', data.row?.value);
    }
  },
};
</script>
<template>
  <div>
    <div class="resource-containers mb-10">
      <div class="headers">
        <div>
          <label>{{ t('resourceQuota.headers.resourceType') }}</label>
        </div>
        <div>
          <label>{{ t('resourceQuota.headers.projectLimit') }}</label>
        </div>
        <div>
          <label>{{ t('resourceQuota.headers.namespaceDefaultLimit') }}</label>
        </div>
      </div>
      <div class="pl-10">
        <label>{{ t('asyncButton.default.action') }}</label>
      </div>
    </div>
    <ArrayList
      v-model="typeValues"
      label="Resources"
      :add-label="t('resourceQuota.add.label')"
      :default-add-value="remainingTypes()[0] ? remainingTypes()[0].value : ''"
      :add-allowed="remainingTypes().length > 0"
      :mode="mode"
      @remove="emitRemove"
    >
      <template #columns="props">
        <Row v-model="value" :mode="mode" :types="remainingTypes(typeValues[props.i])" :type="typeValues[props.i]" @type-change="updateType(props.i, $event)" />
      </template>
    </ArrayList>
  </div>
</template>
<style lang="scss" scoped>
.headers {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    height: 44px;
    width: 100%;
    gap: 10px;

    div {
        width: 100%;
        border-right: 1px solid #DCDDDE;
        padding: 0 10px;
        line-height: 44px;
        label {
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #161C24;
          line-height: 20px;
        }
    }
}
.resource-containers {
  grid-template-columns: auto 75px;
  border-top: 1px solid #DCDDDE;
  border-bottom: 1px solid #DCDDDE;
  display: grid;
  align-items: center;
  background: #F6F6F6;
  label {
    height: 20px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #161C24;
    line-height: 20px;
  }
}
</style>
